module.exports = __webpack_public_path__ + "img/p30615.158a3190.jpg";